import React from 'react';
import PropTypes from 'prop-types';

/* IMPORTING DISCLIAMER STYLES */
import '../../assets/components/Disclaimer.scss';


export const Disclaimer = ({ disclaimer }) => {
    return (
        <>
            <div className="disclaimer-icon">
                <i className="bi bi-exclamation-diamond-fill"></i>
            </div>
            <h4>
                { disclaimer }
            </h4>
        </>
    );
};

Disclaimer.propTypes = {
/* 
    disclaimer for component
*/ 
      disclaimer: PropTypes.string.isRequired,
  }
  
Disclaimer.defaultProps = {
/*
    default value if disclaimer is not given
*/
    disclaimer: '',
}